import { register } from '!/repository'
import { model as root } from '$/tv/сhannels'
import { genPagesLogic } from '@/effector'
import { nay, T } from '@/helpers'
import { api } from '@setplex/tria-api'
import { createEvent, restore, sample } from 'effector'
import { not } from 'patronum'
import { model as tvCategoryModel } from '~/entities/tv/category'

export const initTvCategoryPage = createEvent<{
  categoryId: string
  query: URLSearchParams
}>()
export const left = createEvent()

export const updateTvChannel = createEvent<{
  favorite: boolean
  id: number
}>()

sample({
  clock: initTvCategoryPage,
  filter: not(api.tv.initChannelsCategoryFx.pending),
  fn: ({ categoryId }) => ({
    categoryId: Number(categoryId),
  }),
  target: api.tv.initChannelsCategoryFx,
})

sample({
  clock: updateTvChannel,
  fn: ({ favorite, id }) => ({ favorite: !favorite, id }),
  target: api.tv.updateTvChannelFx,
})

export const loadMoreChannelsByCategory = genPagesLogic(
  api.tv.$channelsByCategoryPageInfo,
  api.tv.loadChannelsFx
)

/** Skeleton start*/
export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

/** Skeleton end*/

// *
// * STORES
// *

/********** Skeleton logics starts ***********/

sample({
  clock: initTvCategoryPage,
  fn: T,
  target: setContentLoading,
})

sample({
  clock: api.tv.loadChannelsFx.pending,
  filter: nay,
  target: setContentLoading,
})

/********** Skeleton logics ends ***********/

// clear paginatable stores
api.tv.$channelsByCategory.reset(initTvCategoryPage)

register(tvCategoryModel.$channelsByCategory, '$channelsByCategory')
register(updateTvChannel, 'updateTvChannel')
register(loadMoreChannelsByCategory, 'loadMoreChannelsByCategory')
register(root.$infiniteTvTitle, '$tv/category/infiniteTvTitle')
